import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const HowtoRenewHMRCMLR = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "How to Renew HMRC MLR?";

  const title = "How to Renew HMRC MLR?";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>How to Renew HMRC MLR? | MSB</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="How to Renew HMRC MLR? | MSB" />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
             <h1 className="page_title text-white">
            How to Renew HMRC MLR?
            </h1>
            {/* <motion.h1
                          className="page_title text-white"
                          initial="hidden"
                          animate="visible"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap", // wrap text across lines
                            textAlign: "center",
                          }}
                        >
                          {title.split(/(\/n)/).map((segment, i) => {
                            if (segment === "/n") {
                              return <br key={`br-${i}`} />;
                            }
            
                            return segment.split("").map((letter, index) => (
                              <motion.span
                                key={`${i}-${index}`}
                                custom={index}
                                variants={letterVariants}
                                style={{
                                  display: "inline-block",
                                  marginRight: letter === " " ? "0.3rem" : "0",
                                  whiteSpace: "pre",
                                }}
                              >
                                {letter}
                              </motion.span>
                            ));
                          })}
                        </motion.h1> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/how-to-series">How to Series?</NavLink>
              </li>
              <li className="active">
                <a href="#!">How to Renew HMRC MLR?</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              {/* <h2 className="item_details_heading">
                      {headingText.split("").map((char, i) => (
                        <motion.span
                          key={`${char}-${i}`}
                          custom={i}
                          initial="hidden"
                          animate="visible"
                          variants={headingVariants}
                        >
                          {char}
                        </motion.span>
                      ))}
                    </h2> */}
              <div className="d-flex justify-content-end mb-3">
                <NavLink
                  to="/how-to-series"
                  className="btn bg-primary text-dark"
                >
                  &larr; Back
                </NavLink>
              </div>
              <img
                className="rounded-2"
                src="assets/images/how-to-series/how-to-renew-hmrc-mlr.png"
                alt="How to Renew HMRC MLR?"
              />

              <h4 className="mt-4">&#10162; Overview</h4>
              <p>
                Renewing your Money Laundering Regulations (MLR) registration
                with HMRC is crucial for compliance if the renewal date is
                passed you are not allowed to trade till new registration is
                received. Follow these steps in renewal process.
              </p>

              <h4>&#10162; Step 1: Check Renewal Timeline</h4>
              <p>
                Be aware of your registration expiry date and start the renewal
                process at least 3 months in advance.
              </p>

              <h4>&#10162; Step 2: Gather Required information</h4>
              <p className="mb-3">
                You will need to provide specific financial information for your
                business, including:
              </p>
              <ul className="mb-4">
                <li>
                  <h6>Number of Transactions</h6>
                  <p className="mb-3">
                    Include the total number of transactions conducted in the
                    previous year.
                  </p>
                </li>
                <li>
                  <h6>Turnover</h6>
                  <p className="mb-3">
                    Report your total business turnover for last 12 months.
                  </p>
                </li>
                <li>
                  <h6>Profits</h6>
                  <p className="mb-3">
                    Provide details of your profits for last 12 months.
                  </p>
                </li>
                <li>
                  <h6>Expected Figures for the Next 12 Months</h6>
                  <p>
                    Estimate the number of transactions, turnover, and profits
                    you anticipate for the upcoming year. This information helps
                    HMRC assess your business's scale and associated risks.
                  </p>
                </li>
              </ul>

              <h4>&#10162; Step 3: Complete the Online Application</h4>
              <ul className="mt-3 mb-4">
                <li>
                  <p className="mb-3">
                    Log in to the HMRC portal and fill out the MLR renewal
                    application.
                  </p>
                </li>
                <li>
                  <p>Ensure all information is accurate and complete.</p>
                </li>
              </ul>

              <h4>&#10162; Step 4: Submit Payment</h4>
              <ul className="mt-3 mb-4">
                <li>
                  <p>Pay the required renewal fee as specified by HMRC.</p>
                </li>
              </ul>

              <h4>&#10162; Step 5: Confirmation and Follow-Up</h4>
              <ul className="mt-3 mb-4">
                <li>
                  <p>
                    After submission, monitor your application status and
                    respond promptly to any HMRC queries.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HowtoRenewHMRCMLR;
